export default {
  en: {
    i18n: {
      langShort: 'en',
      langLong: 'English',
      english: 'English',
      czech: 'Česky',
    },
    loginPage: {
      title: 'Login',
      message: 'Welcome back to Cashcap!',
      email: 'Email',
      password: 'Password',
      forgotPasswordBtn: 'Forgot password?',
      registerBtn: 'Register',
      noAccountPrefix: 'You dont have an account?',
      registerHere: 'Register here',
      loginBtn: 'Login',
      emptyErr: 'Please fill both username and password to sign in!',
      invalidErr: 'The username or password is incorrect!',
      invalidFormatErr: 'Password or username has incorrect format or is empty!',
      serviceErr: 'We could not sign you in right now. Please try again.',
    },
    logoutPage: {
      title: 'You have been logged out',
      description: 'You can sign in again to continue using Cashcap.',
      signInBtn: 'Sign in',
    },
    registerPage: {
      title: 'Create new account',
      fullname: 'Full name',
      companyName: 'Company name',
      email: 'Email',
      password: 'Password',
      passwordAgain: 'Password again',
      alreadyRegistered: 'Already registered?',
      signInBtn: 'Sign in',
      submitBtn: 'Submit',
      registerBtn: 'Register',
      registrationSuccessful: 'Registration successful',
      passwordRequiredErr: 'Password is required',
      nameRequiredErr: 'Name is required',
      nameTooLongErr: 'Name must be 255 characters or fewer',
      companyNameRequiredErr: 'Company name is required',
      companyNameTooLongErr: 'Company name must be 255 characters or fewer',
      emailTooLongErr: 'Email must be 255 characters or fewer',
      differentPasswordsErr: 'Passwords must match',
      weakPasswordErr:
        'Password must be at least 8 characters long and contain at least one letter and one number. Spaces and accented characters are not allowed.',
      invalidEmailErr: 'Invalid email format',
      welcomeToCashCapMsg: 'Welcome to CashCap!',
      tierLimitAdminsErr: 'Admin limit for your current subscription tier has been reached',
      tierLimitMembersErr: 'Member limit for your current subscription tier has been reached',
      tierLimitProjectsErr: 'Project limit for your current subscription tier has been reached',
    },
    forgottenPasswordPage: {
      title: 'Forgotten password',
      message: 'Please fill out your email, where we will send you a password renewal link.',
      email: 'Email',
      signIn: 'Sign in',
      invalidEmailErr: 'Please enter a valid email',
      resetEmailSentMsg: 'An email with a reset password link has been sent to your email address',
    },
    resetPasswordPage: {
      title: 'Reset your password',
      password: 'Password',
      passwordAgain: 'Password again',
      signIn: 'Sign in',
      emptyFieldErr: 'You must fill both fields',
      differentPasswordsErr: 'Passwords must match',
      weakPasswordErr:
        'Password must contain at least one letter and one number and be at least 8 characters long',
      passwordChangedMsg: 'Your password has been successfully changed',
    },
    checkoutPage: {
      title: 'Complete Purchase',
      billingInfoHeader: 'Billing Information',
      termsAgreement: 'I agree to the',
      termsLink: 'Privacy Policy',
      backBtn: 'Back',
      proceedBtn: 'Proceed to Payment',
      processingBtn: 'Processing...',
      termsNotAgreedErr: 'You must agree to the Privacy Policy',
      invalidBillingDataErr: 'Please fill in all required billing information',
      paymentInitiationFailedErr: 'Error initiating payment',
      admins: 'Admin',
      members: 'Member',
      projects: 'Project',
      selectTierHeader: 'Select your subscription tier',
      selectPeriodHeader: 'Choose billing period',
      annualDiscountBadge: 'Yearly deal',
      annualDiscountHeadline: 'Get 2 months free on yearly billing',
      annualDiscountDescription: 'Pay for 10 months instead of 12 when you commit for a full year.',
      annualDiscountSavings: 'Save {amount} {currency}',
      freeTrialHeadline: 'Get 3 weeks free',
      trialEligibilityInfo:
        'You are eligible for a free trial. You will be billed only after the first three weeks.',
    },
    paymentStatusPage: {
      processing: 'Refreshing your account access...',
      callbackSyncFailed:
        'We could not refresh your account automatically. Please refresh later or contact support.',
      goHomeBtn: 'Go Home',
      backToCheckoutBtn: 'Back to Checkout',
      paid: {
        title: 'Payment completed',
        description: 'Your payment has been received. You can continue back to the application.',
      },
      cancelled: {
        title: 'Payment cancelled',
        description:
          'The payment was cancelled before completion. You can return to checkout and try again.',
      },
      pending: {
        title: 'Payment pending',
        description:
          'The payment is still being processed. We will unlock the subscription after confirmation.',
      },
    },
    common: {
      submit: 'Submit',
      fixErrors: 'Please correct the following errors:',
      multiselectFilter: {
        label: ({ values: { selected, total } }) => `Selected ${selected} / ${total}`,
        selectAll: 'Select all',
        selectNo: 'Deselect all',
      },
    },
    leftMenu: {
      home: 'Home',
      companies: 'Companies',
      settings: 'Settings',
    },
    termsPage: {
      title: 'Terms and Conditions',
      backBtn: 'Back',
      section1Title: '1. Introduction',
      section1Content:
        'Welcome to CashCap. These Terms and Conditions govern your use of our service. By accessing and using this service, you accept and agree to be bound by the terms and provision of this agreement.',
      section2Title: '2. Use License',
      section2Content:
        "Permission is granted to temporarily download one copy of the materials (information or software) on CashCap's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not: modify or copy the materials; use the materials for any commercial purpose or for any public display; attempt to decompile or reverse engineer any software contained on the website; remove any copyright or other proprietary notations from the materials; or transfer the materials to another person or 'mirror' the materials on any other server.",
      section3Title: '3. Disclaimer',
      section3Content:
        "The materials on CashCap's website are provided on an 'as is' basis. CashCap makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.",
      section4Title: '4. GDPR and Data Protection',
      section4Content:
        'CashCap is committed to protecting your personal data in accordance with the General Data Protection Regulation (GDPR) and other applicable data protection laws. We collect and process personal data only for specified, explicit, and legitimate purposes. You have the right to access, rectify, erase, and restrict the processing of your personal data. For more information about how we handle your data, please refer to our Privacy Policy.',
      section5Title: '5. Limitation of Liability',
      section5Content:
        "In no event shall CashCap or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on CashCap's website, even if CashCap or an authorized representative has been notified orally or in writing of the possibility of such damage.",
      section6Title: '6. Accuracy of Materials',
      section6Content:
        "The materials appearing on CashCap's website could include technical, typographical, or photographic errors. CashCap does not warrant that any of the materials on its website are accurate, complete, or current. CashCap may make changes to the materials contained on its website at any time without notice.",
      section7Title: '7. Links',
      section7Content:
        "CashCap has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by CashCap of the site. Use of any such linked website is at the user's own risk.",
      section8Title: '8. Modifications',
      section8Content:
        'CashCap may revise these terms of service for its website at any time without notice. By using this website, you are agreeing to be bound by the then current version of these terms of service.',
      section9Title: '9. Governing Law',
      section9Content:
        'These terms and conditions are governed by and construed in accordance with the laws of the Czech Republic, and you irrevocably submit to the exclusive jurisdiction of the courts in that location.',
    },
    topMenu: {
      changeInfo: 'Change profile info',
      changePassword: 'Change password',
      changePasswordCardTitle: 'Change your password',
      changeNewPassword: 'Change new password',
      logout: 'Logout',
      profileInfoTitle: 'Profile info',
      profileCardTitle: 'Profile',
      name: 'Name',
      email: 'Email',
      edit: 'Edit',
      phone: 'Phone',
      password: 'Password',
      language: 'Preferred language',
      currentPassword: 'Current password',
      newPassword: 'New password',
      repeatNewPassword: 'Repeat new password',
      forgotPassword: 'Forgot password?',
      currentPasswordPlaceholder: 'Current password',
      newPasswordPlaceholder: 'New password',
      repeatNewPasswordPlaceholder: 'Repeat new password',
      saveBtn: 'Save changes',
      shortNameErr: 'Your name should be at least 4 characters long',
      invalidEmailErr: 'The email format is invalid',
      currentPasswordRequiredErr: 'Your current password is required',
      newPasswordRequiredErr: 'New password is required',
      repeatNewPasswordRequiredErr: 'Repeat new password is required',
      differentPasswordErr: 'New password must be different from old one',
      passwordsDoNotMatchErr: 'New passwords do not match',
      weakPasswordErr:
        'Password must contain at least one letter and one number and be at least 8 characters long',
      invalidCurrentPassword: 'Given current password is invalid',
      passwordChangedMsg: 'Password changed successfully',
      infoChangedMsg: 'Information has been changed',
    },
    bottomMenu: {
      backToTop: 'Back to top',
    },
    homePage: {
      trialWarning: 'Trial Period Active',
      trialEndsIn: 'Your trial ends in {days} days',
      welcome: 'Welcome back, {userName}.',
      managedCompanies: ({ values: { numberOfProjects } }) => {
        return `You manage ${numberOfProjects} ${numberOfProjects === 1 ? 'company' : 'companies'}.`;
      },
      cashFlow: 'Cash Flow',
      capacities: 'Capacities',
      people: 'People',
      projects: 'Projects',
      timesheet: 'Timesheet',
      workReports: 'Work Reports',
      delete: 'Delete',
      edit: 'Edit',
      create: 'New company',
      createCompanyDialog: {
        createTitle: 'Create new Company',
        editTitle: 'Edit Company',
        namePlaceholder: 'COMPANY NAME',
        balancePlaceholder: 'INITIAL BALANCE',
        balanceTooltip:
          'Initial ballance is a starting point for your cashflow management in cashcap. If you start from scratch, leave a 0. If you are already working on a project or company, put in the amount of cash availible on your bank account by the end of last month.',
        createBtn: 'Create',
        editBtn: 'Save changes',
        tierLimitProjectsErr: 'Project limit for your current subscription tier has been reached',
      },
      deleteCompanyDialog: {
        title: 'Do you want to delete?',
        deleteBtn: 'Delete',
      },
      goToCheckout: 'Go to checkout',
    },
    settingsPage: {
      title: 'Settings for {companyName}',
      inviteHeader: 'Invite user',
      userEmail: 'Email',
      inviteBtn: 'Invite',
      invitationEmailRequiredErr: 'Email is required',
      invitationEmailInvalidErr: 'Please enter a valid email format',
      invitationSentMsg: 'Invitation has been sent',
      userSettingsHeader: 'Users settings',
      nameEmailRoleColumn: 'Name, Email, Role',
      assignedProjectsColumn: 'Assigned Projects',
      employeesColumn: 'People',
      resetPasswordDeleteUserLabel: 'Reset password, Delete user',
      roleLabel: 'Role',
      saveBtn: 'Save',
      allProjects: 'All projects',
      allEmployees: 'All people',
      assignedEmployees: 'Assigned people to fill',
      favoriteEmployee: 'Favorite person',
      noAssignedEmployees: '(none)',
      noFavoriteEmployee: '(none)',
      setFavoriteEmployeeBtn: 'Set',
      assignProjectBtn: 'Assign',
      unassignProjectBtn: 'Unassign',
      assignEmployeeBtn: 'Assign',
      editProfileBtn: 'Edit profile',
      resetBtn: 'Reset password',
      deleteBtn: 'Delete',
      billingInformationHeader: 'Billing Information',
      saveBillingInfoBtn: 'Save Billing Information',
      billingInfoSavedMsg: 'Billing information has been successfully saved',
      cancelSubscriptionBtn: 'Cancel Subscription',
      cancelSubscriptionModalTitle: 'Cancel Subscription',
      cancelSubscriptionModalDescription:
        'Please tell us why you are cancelling your subscription.',
      cancelSubscriptionReasonPlaceholder: 'Reason for cancellation',
      cancelSubscriptionReasonRequiredErr: 'Cancellation reason is required',
      cancelSubscriptionModalBackBtn: 'Back',
      cancelSubscriptionModalConfirmBtn: 'Confirm cancellation',
      cancelSubscriptionInProgressBtn: 'Cancelling...',
      subscriptionCancelledMsg: 'Subscription has been cancelled successfully',
      subscriptionCancelFailedErr: 'Failed to cancel subscription',
      restartSubscriptionBtn: 'Restart Subscription',
      restartSubscriptionInProgressBtn: 'Restarting...',
      subscriptionRestartedMsg: 'Subscription has been restarted successfully',
      subscriptionRestartFailedErr: 'Failed to restart subscription',
      subscriptionManagementHeader: 'Subscription Management',
      subscriptionCancelledStatus: 'Your subscription has been cancelled.',
      resumeSubscriptionBtn: 'Resume Subscription',
      resumeSubscriptionInProgressBtn: 'Resuming...',
      subscriptionResumedMsg: 'Subscription has been resumed successfully',
      subscriptionResumeFailedErr: 'Failed to resume subscription',
      manageSubscriptionBtn: 'Manage Subscription',
      currentSubscriptionTier: 'Current subscription tier',
      subscriptionCancelledRenewHint:
        'Your subscription is not active. You can renew it with the button bellow.',
      subscriptionTierLevel: 'Subscription Tier',
      subscriptionPrice: 'Price',
      subscriptionPaymentStatus: 'Payment Status',
      subscriptionNextPaymentDate: 'Next Payment Date',
      subscriptionTrialEndsAt: 'Trial Ends',
      subscriptionEndsAt: 'Subscription Ends',
      subscriptionBillingPeriod: 'Billing Period',
      subscriptionPeriodMonthly: 'Monthly',
      subscriptionPeriodAnnually: 'Annually',
      subscriptionTrialStatus: 'Trial',
      subscriptionActiveStatus: 'Active',
      subscriptionProcessingStatus: 'Processing',
      subscriptionPendingStatus: 'Pending',
      subscriptionUnpaidStatus: 'Unpaid',
      subscriptionNoSubscriptionStatus: 'No subscription',
      subscriptionTierLimits: 'Tier Limits',
      subscriptionAdminLimit: 'Admins',
      subscriptionMemberLimit: 'Members',
      subscriptionProjectLimit: 'Projects',
      noSubscriptionTitle: 'No subscription yet',
      noSubscriptionDescription:
        'Start a subscription to unlock paid features and recurring billing.',
      lastPaymentErrorReason: 'Last payment issue',
      tierLimitAdminsErr: 'Admin limit for your current subscription tier has been reached',
      tierLimitMembersErr: 'Member limit for your current subscription tier has been reached',
      tierLimitProjectsErr: 'Project limit for your current subscription tier has been reached',
    },
    subscription: {
      requiresSubscription: 'This feature requires a valid subscription',
      freeTrialHeadline: 'Start with 3 weeks free',
      checkoutRequirement:
        'This is a paid feature. First, enter your payment details and verify your card. Your first charge comes after the 3-week free trial.',
      tiers: {
        individual: 'Individual',
        team: 'Team',
        organization: 'Organization',
      },
    },
    billingForm: {
      firstName: 'First Name',
      lastName: 'Last Name',
      address: 'Address',
      city: 'City',
      state: 'State',
      zipCode: 'Zip Code',
      country: 'Country',
      contactEmail: 'Main Contact Email',
      contactPhone: 'Main Contact Phone',
      companyInfo: 'Company Information',
      companyInfoOptional: '(optional)',
      companyName: 'Company Name',
      ico: 'IČ',
      dic: 'DIČ',
      errors: {
        required: 'This field is required',
        email: 'Enter a valid email address',
        country: 'Select a valid country',
        phoneLength: 'Phone number must be at most 20 characters',
      },
    },
    cashFlowPage: {
      title: '{projectName}: Finance',
      companyOverview: 'Company overview',
      previousMonth: 'Previous month',
      nextMonth: 'Next month',
      showDeletedItems: 'Show deleted items',
      showHiddenItems: 'Show hidden items',
      hideDeletedItems: 'Hide deleted items',
      hideItems: 'Hide items',
      months: {
        '01': 'January',
        '02': 'February',
        '03': 'March',
        '04': 'April',
        '05': 'May',
        '06': 'June',
        '07': 'July',
        '08': 'August',
        '09': 'September',
        10: 'October',
        11: 'November',
        12: 'December',
      },
      categories: {
        'saldo-cumulative': 'Cumulative Balance',
        'saldo-forecast-cumulative': 'Cumulative Forecasted Balance',
        'forecast-cumulative': 'Cumulative Forecast',
        forecast: 'Forecast',
        'saldo-internal': 'Internal Projects Balance',
        saldo: 'Balance',
        income: 'Incomes',
        expense: 'Expenses',
        'vat-estimate': 'VAT estimate',
        'vat-reality': 'VAT reality',
        1: 'Expenses',
        2: 'Incomes',
        3: 'Forecast Expenses',
        4: 'Forecast Incomes',
        5: 'Salaries',
        6: 'Internal Projects',
      },
      defaultCapacityDialog: {
        title({ values: { employee } }) {
          return `Default capacity${employee ? ' for ' + employee.name : ''}`;
        },
        submitBtn: 'Submit',
      },
      vatSelectDialog: {
        editTitle: 'Edit VAT rates',
        selectTitle: 'Select VAT rate',
        noneLabel: 'None',
      },
      aggregation: {
        sum: 'Sum',
        average: 'Average',
        min: 'Minimum',
        max: 'Maximum',
        count: 'Count',
      },
    },
    capacitiesPage: {
      title: '{projectName}: Capacities',
      weekTitle: 'Week {weekNumber}',
      projectsHeader: 'Projects',
      previousWeek: 'Previous week',
      nextWeek: 'Next week',
      employee: 'Person',
      capacity: 'Capacity',
      description: 'Description',
      utilization: 'Utilization',
      workingHours: 'Availible capacity',
      plan: 'Plan',
      fact: 'Fact',
      addNewEmployee: 'Add new person',
      addNewProject: 'Add new project',
      assignInternalProject: 'Assign Internal Project',
      showDeletedItems: 'Show deleted items',
      showHiddenItems: 'Show hidden items',
      hideDeletedItems: 'Hide deleted items',
      hideItems: 'Hide items',
    },
    employeesPage: {
      title: '{projectName}: People',
      employeesHeader: 'People',
      addNewEmployee: 'Add new person',
      previousWeek: 'Previous week',
      nextWeek: 'Next week',
      weeksLabel: 'Week {start} - {end}',
      weekTitle: 'Week {weekNumber}',
      plan: 'Plan',
      fact: 'Fact',
      capacity: 'Cap',
      noAssignedProjects: 'This person does not have any projects assigned.',
      assignProject: 'Assign Project',
      assignProjectTo: 'Assign project to {employeeName}',
    },
    projectsPage: {
      title: '{projectName}: Projects',
      projectsHeader: 'Projects',
      addNewProject: 'Add new project',
      previousWeek: 'Previous week',
      nextWeek: 'Next week',
      weeksLabel: 'Week {start} - {end}',
      weekTitle: 'Week {weekNumber}',
      plan: 'Plan',
      fact: 'Fact',
    },
    timesheetsPage: {
      title: '{projectName}: Timesheet',
      selectPerson: 'Select person',
      weekTitle: 'Week {weekNumber}',
      projectsHeader: 'Projects',
      previousWeek: 'Previous week',
      nextWeek: 'Next week',
      'calculated-plan': 'Plan',
      'calculated-fact': 'Fact',
      'calculated-capacity': 'Capacity',
      'calculated-onload': 'Onload',
      assignProject: 'Assign Project',
      showHiddenItems: 'Show hidden items',
      hideItems: 'Hide items',
      columnHeader: ({ values: { columnId } }) => {
        if (columnId === 'total-plan') {
          return 'TOTAL PlAN';
        }
        if (columnId === 'total-fact') {
          return 'TOTAL FACT';
        }
        const date = new Date(columnId);
        const [, m, d] = columnId.split('-');
        const dayNum = date.getDay();
        const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return `${days[dayNum]} ${d}. ${m}.`;
      },
    },
    workReportsPage: {
      title: '{projectName}: Work Reports',
      workReportsHeader: 'Work Reports',
      projectColumn: 'Project:',
      employeeColumn: 'Employee:',
      employeeDialogSearchPlaceholder: 'Name...',
      projectDialogSearchPlaceholder: 'Project...',
      dateColumn: 'Date:',
      invoiceColumn: 'Invoice:',
      noteColumn: 'Note:',
      hoursColumn: 'Hours:',
      yesNoBoolean: {
        1: 'Yes',
        0: 'No',
        null: '-',
      },
      csvExportBtn: 'CSV Export',
      saveRow: 'Save',
      discardRow: 'Discard changes',
      resetRow: 'Reset',
      deleteNewRow: 'Delete',
      newWorkReport: 'New Work Report',
      itemsPerPage: 'Rows per page',
      forceUpdateDialog: {
        title:
          'A work report for the given employee, project and day with a filled time, note or invoice already exists. Do you want to overwrite it?',
        overwriteBtn: 'Overwrite',
        cancelBtn: 'Cancel',
      },
      assignProject: 'Assign Project',
    },
  },
  cs: {
    i18n: {
      langShort: 'cs',
      langLong: 'Česky',
      english: 'English',
      czech: 'Česky',
    },
    loginPage: {
      title: 'Login',
      message: 'Vítejte zpět v Cashcap!',
      email: 'Email',
      password: 'Heslo',
      forgotPasswordBtn: 'Zapomenuté heslo?',
      registerBtn: 'Registrovat',
      noAccountPrefix: 'Nemáte účet?',
      registerHere: 'Registrovat zde',
      loginBtn: 'Přihlásit se',
      emptyErr: 'Prosím vyplňte uživatelské jméno a heslo pro přihlášení!',
      invalidErr: 'Uživatelské jméno nebo heslo je nesprávné!',
      invalidFormatErr: 'Uživatelské jméno nebo heslo má nesprávný formát!',
      serviceErr: 'Nyní vás nemůžeme přihlásit. Zkuste to prosím znovu.',
    },
    logoutPage: {
      title: 'Byli jste odhlášeni',
      description: 'Pro pokračování v Cashcap se můžete znovu přihlásit.',
      signInBtn: 'Přihlásit se',
    },
    registerPage: {
      title: 'Vytvořit nový účet',
      fullname: 'Celé jméno',
      companyName: 'Název společnosti',
      email: 'Email',
      password: 'Heslo',
      passwordAgain: 'Heslo znovu',
      alreadyRegistered: 'Už máte účet?',
      signInBtn: 'Přihlásit se',
      submitBtn: 'Registrovat',
      registerBtn: 'Registrovat',
      registrationSuccessful: 'Úspěšná registrace',
      passwordRequiredErr: 'Heslo je vyžadováno',
      nameRequiredErr: 'Jméno je vyžadováno',
      nameTooLongErr: 'Jméno může mít maximálně 255 znaků',
      companyNameRequiredErr: 'Název společnosti je vyžadován',
      companyNameTooLongErr: 'Název společnosti může mít maximálně 255 znaků',
      emailTooLongErr: 'Email může mít maximálně 255 znaků',
      differentPasswordsErr: 'Hesla se musí shodovat',
      weakPasswordErr:
        'Heslo musí mít alespoň 8 znaků, obsahovat alespoň jedno písmeno a jednu číslici. Mezery a znaky s diakritikou nejsou povoleny.',
      invalidEmailErr: 'Chybný formát emailu',
      welcomeToCashCapMsg: 'Vítejte v CashCap!',
      tierLimitAdminsErr: 'Byl dosažen limit administrátorů pro vaši úroveň předplatného',
      tierLimitMembersErr: 'Byl dosažen limit členů pro vaši úroveň předplatného',
      tierLimitProjectsErr: 'Byl dosažen limit projektů pro vaši úroveň předplatného',
    },
    forgottenPasswordPage: {
      title: 'Zapomenuté heslo',
      message: 'Prosím vyplňte email, kam Vám přijde odkaz pro obnovu heslo.',
      email: 'Email',
      signIn: 'Přihlásit se',
      invalidEmailErr: 'Prosím vyplňte validní email',
      resetEmailSentMsg: 'Email s odkazem pro obnovu hesla byl odeslán na Váš email',
      invalidErr: 'Uživatelské jméno nebo heslo je nesprávné!',
    },
    resetPasswordPage: {
      title: 'Resetujte Vaše heslo',
      password: 'Heslo',
      passwordAgain: 'Heslo znovu',
      signIn: 'Přihlásit se',
      emptyFieldErr: 'Musíte vyplnit obě pole',
      differentPasswordsErr: 'Hesla se muís shodovat',
      weakPasswordErr:
        'Heslo musí obsahovat alespoň jedno písmeno, jednu číslici a být minimálně 8 znaků dlouhé',
      passwordChangedMsg: 'Vaše heslo bylo úspěšně změněno',
    },
    common: {
      submit: 'Odeslat',
      fixErrors: 'Prosím opravte následující chyby:',
      multiselectFilter: {
        label: ({ values: { selected, total } }) => `Vybráno ${selected} / ${total}`,
        selectAll: 'Vybrat vše',
        selectNo: 'Zrušit vše',
      },
    },
    leftMenu: {
      home: 'Domů',
      settings: 'Nastavení',
      companies: 'Společnosti',
    },
    topMenu: {
      changeInfo: 'Upravit profil',
      changePassword: 'Změnit heslo',
      changePasswordCardTitle: 'Změňte si heslo',
      changeNewPassword: 'Změnit nové heslo',
      logout: 'Odhlásit se',
      profileInfoTitle: 'Informace o profilu',
      profileCardTitle: 'Profil',
      name: 'Jméno',
      email: 'Email',
      edit: 'Upravit',
      phone: 'Telefon',
      password: 'Heslo',
      language: 'Preferovaný jazyk',
      currentPassword: 'Stávající heslo',
      newPassword: 'Nové heslo',
      repeatNewPassword: 'Zopakujte nové heslo',
      forgotPassword: 'Zapomněli jste heslo?',
      currentPasswordPlaceholder: 'Stávající heslo',
      newPasswordPlaceholder: 'Nové heslo',
      repeatNewPasswordPlaceholder: 'Zopakujte nové heslo',
      saveBtn: 'Uložit',
      shortNameErr: 'Vaše uživatelské jméno musí být alespoň 4 znaky dlouhé',
      invalidEmailErr: 'Formát emailu je chybný',
      currentPasswordRequiredErr: 'Stávající heslo je vyžadováno',
      newPasswordRequiredErr: 'Nové heslo je vyžadováno',
      repeatNewPasswordRequiredErr: 'Je vyžadováno zopakování nového hesla',
      differentPasswordErr: 'Nové heslo musí být rozdílné od stávajícího',
      passwordsDoNotMatchErr: 'Nová hesla se neshodují',
      weakPasswordErr:
        'Heslo musí obsahovat alespoň jedno písmeno, jednu číslici a být minimálně 8 znaků dlouhé',
      invalidCurrentPassword: 'Zadané stávající heslo je nespávné',
      passwordChangedMsg: 'Heslo bylo úspěšně změněno',
      infoChangedMsg: 'Informace byly změněny',
    },
    bottomMenu: {
      backToTop: 'Zpět nahoru',
    },
    homePage: {
      trialWarning: 'Zkušební období aktivní',
      trialEndsIn: 'Vaše zkušební období skončí za {days} dní',
      welcome: 'Vítejte zpět, {userName}.',
      managedCompanies: ({ values: { numberOfProjects } }) => {
        const projectSpelling = {
          1: 'společnost',
          2: 'společnosti',
          3: 'společnosti',
          4: 'společnosti',
          other: 'společností',
        };
        return `Spravujete ${numberOfProjects} ${projectSpelling[numberOfProjects] || projectSpelling.other}.`;
      },
      cashFlow: 'Cash Flow',
      capacities: 'Kapacity',
      people: 'Lidé',
      projects: 'Projekty',
      timesheet: 'Timesheet',
      workReports: 'Výkazy práce',
      delete: 'Smazat',
      edit: 'Upravit',
      create: 'Vytvořit novou společnost',
      createCompanyDialog: {
        createTitle: 'Vytvořit novou společnost',
        editTitle: 'Upravit společnost',
        namePlaceholder: 'NÁZEV SPOLEČNOSTI',
        balancePlaceholder: 'POČÁTEČNÍ BILANCE',
        balanceTooltip:
          'Počáteční bilance je startovní bod vaší cashflow v cashcap. Pokud začínáte od nuly, nechte ji nulovou. Pokud na projektu nebo společnosti už pracujete, zadejte zůstatek na účtu na konci minulého měsíce.',
        createBtn: 'Vytvořit',
        editBtn: 'Uložit změny',
        tierLimitProjectsErr: 'Byl dosažen limit projektů pro vaši úroveň předplatného',
      },
      deleteCompanyDialog: {
        title: 'Chcete smazat?',
        deleteBtn: 'Smazat',
      },
      goToCheckout: 'Přejít na platbu',
    },
    checkoutPage: {
      title: 'Dokončit nákup',
      billingInfoHeader: 'Fakturační údaje',
      termsAgreement: 'Souhlasím se',
      termsLink: 'Zásadami zpracování osobních údajů',
      backBtn: 'Zpět',
      proceedBtn: 'Pokračovat na platbu',
      processingBtn: 'Zpracování...',
      termsNotAgreedErr: 'Musíte souhlasit se zásadami zpracování osobních údajů',
      invalidBillingDataErr: 'Vyplňte prosím všechny povinné fakturační údaje',
      paymentInitiationFailedErr: 'Chyba při iniciaci platby',
      admins: 'Administrátor',
      members: 'Člen',
      projects: 'Projekt',
      selectTierHeader: 'Vyberte úroveň předplatného',
      selectPeriodHeader: 'Vyberte fakturační období',
      annualDiscountBadge: 'Roční zvýhodnění',
      annualDiscountHeadline: 'Získejte 2 měsíce zdarma při roční platbě',
      annualDiscountDescription: 'Při závazku na celý rok zaplatíte jen 10 měsíců místo 12.',
      annualDiscountSavings: 'Ušetříte {amount} {currency}',
      freeTrialHeadline: 'Získejte 3 týdny zdarma',
      trialEligibilityInfo:
        'Máte nárok na zkušební období zdarma. Platba vám bude účtována až po prvních třech týdnech.',
    },
    paymentStatusPage: {
      processing: 'Obnovuji přístup k vašemu účtu...',
      callbackSyncFailed:
        'Účet se nepodařilo obnovit automaticky. Obnovte stránku později nebo kontaktujte podporu.',
      goHomeBtn: 'Přejít domů',
      backToCheckoutBtn: 'Zpět na platbu',
      paid: {
        title: 'Platba dokončena',
        description: 'Platba byla přijata. Můžete pokračovat zpět do aplikace.',
      },
      cancelled: {
        title: 'Platba zrušena',
        description:
          'Platba byla před dokončením zrušena. Můžete se vrátit na checkout a zkusit to znovu.',
      },
      pending: {
        title: 'Platba čeká na potvrzení',
        description: 'Platba se stále zpracovává. Předplatné odemkneme po potvrzení.',
      },
    },
    termsPage: {
      title: 'Podmínky použití',
      backBtn: 'Zpět',
      section1Title: '1. Úvod',
      section1Content:
        'Vítejte v CashCap. Tyto Podmínky použití upravují vaše používání naší služby. Přístupem a používáním této služby přijímáte a souhlasíte s tím, že budete vázáni podmínkami této smlouvy.',
      section2Title: '2. Licence k používání',
      section2Content:
        "Je vám uděleno oprávnění dočasně si stáhnout jednu kopii materiálů (informací nebo softwaru) na webových stránkách CashCap pouze pro osobní, nekomerční dočasné prohlížení. Jedná se o udělení licence, nikoli o převod vlastnictví, a v rámci této licence nesmíte: upravovat nebo kopírovat materiály; používat materiály pro jakýkoli komerční účel nebo pro jakékoli veřejné zobrazení; pokoušet se dekompilovat nebo zpětně analyzovat jakýkoli software obsažený na webových stránkách; odstraňovat jakékoli autorská práva nebo jiné vlastnické poznámky z materiálů; nebo přenášet materiály na jinou osobu nebo 'zrcadlit' materiály na jakémkoli jiném serveru.",
      section3Title: '3. Odmítnutí odpovědnosti',
      section3Content:
        "Materiály na webových stránkách CashCap jsou poskytovány 'tak jak jsou'. CashCap neposkytuje žádné záruky, výslovné nebo předpokládané, a tímto odmítá a neguje všechny ostatní záruky včetně, bez omezení, předpokládaných záruk nebo podmínek prodejnosti, vhodnosti pro konkrétní účel nebo porušení práv duševního vlastnictví nebo jiných práv.",
      section4Title: '4. GDPR a ochrana osobních údajů',
      section4Content:
        'CashCap se zavazuje chránit vaše osobní údaje v souladu s Obecným nařízením o ochraně osobních údajů (GDPR) a dalšími platnými zákony o ochraně osobních údajů. Osobní údaje shromažďujeme a zpracováváme pouze pro specifikované, explicitní a legitimní účely. Máte právo na přístup, opravu, smazání a omezení zpracování vašich osobních údajů. Další informace o tom, jak nakládáme s vašimi údaji, naleznete v našich Zásadách ochrany osobních údajů.',
      section5Title: '5. Omezení odpovědnosti',
      section5Content:
        'CashCap ani jeho dodavatelé nebudou v žádném případě odpovědni za žádné škody (včetně, bez omezení, škod na ztrátě dat nebo zisku, nebo v důsledku přerušení činnosti) vyplývající z používání nebo neschopnosti používat materiály na webových stránkách CashCap, a to ani v případě, že byl CashCap nebo jeho zástupce informován ústně nebo písemně o možnosti takové škody.',
      section6Title: '6. Přesnost materiálů',
      section6Content:
        'Materiály na webových stránkách CashCap mohou obsahovat technické, typografické nebo fotografické chyby. CashCap negarantuje, že některý z materiálů na jeho webových stránkách je přesný, úplný nebo aktuální. CashCap si vyhrazuje právo kdykoli změnit materiály obsažené na svých webových stránkách bez upozornění.',
      section7Title: '7. Odkazy',
      section7Content:
        'CashCap neprověřil všechny weby odkazované na jeho webových stránkách a není odpovědný za obsah žádného takového odkazovaného webu. Zahrnutí jakéhokoli odkazu neznamená schválení webu ze strany CashCap. Používání jakéhokoli takového odkazovaného webu je na vlastní riziko uživatele.',
      section8Title: '8. Změny',
      section8Content:
        'CashCap si vyhrazuje právo kdykoli bez upozornění revidovat tyto podmínky služby pro svůj web. Používáním tohoto webu souhlasíte s tím, že budete vázáni aktuální verzí těchto podmínek služby.',
      section9Title: '9. Rozhodné právo',
      section9Content:
        'Tyto podmínky a ustanovení se řídí zákony České republiky a vy se neodvolatelně podřizujete výlučné pravomoci soudů v tomto místě.',
    },
    settingsPage: {
      title: 'Nastavení pro {companyName}',
      inviteHeader: 'Pozvat uživatele',
      userEmail: 'Email',
      inviteBtn: 'Pozvat',
      invitationEmailRequiredErr: 'Email je vyžadován',
      invitationEmailInvalidErr: 'Prosím zadejte validní formát emailu',
      invitationSentMsg: 'Pozvánka byla poslána',
      userSettingsHeader: 'Nastavení uživatelů',
      nameEmailRoleColumn: 'Jméno, Email, Role',
      assignedProjectsColumn: 'Přiřazené projekty',
      employeesColumn: 'Lidé',
      resetPasswordDeleteUserLabel: 'Resetovat heslo, Smazat uživatele',
      roleLabel: 'Role',
      saveBtn: 'Uložit',
      allProjects: 'Všechny projekty',
      allEmployees: 'Všichni lidé',
      assignedEmployees: 'Lidé přiřazené k vyplňování',
      favoriteEmployee: 'Oblíbený člověk',
      noAssignedEmployees: '(žádní)',
      noFavoriteEmployee: '(žádný)',
      setFavoriteEmployeeBtn: 'Nastavit',
      assignProjectBtn: 'Přiřadit',
      unassignProjectBtn: 'Odebrat',
      assignEmployeeBtn: 'Přiřadit',
      editProfileBtn: 'Upravit profil',
      resetBtn: 'Resetovat heslo',
      deleteBtn: 'Smazat',
      billingInformationHeader: 'Fakturační údaje',
      saveBillingInfoBtn: 'Uložit fakturační údaje',
      billingInfoSavedMsg: 'Fakturační údaje byly úspěšně uloženy',
      cancelSubscriptionBtn: 'Zrušit předplatné',
      cancelSubscriptionModalTitle: 'Zrušení předplatného',
      cancelSubscriptionModalDescription: 'Napište nám prosím, proč rušíte předplatné.',
      cancelSubscriptionReasonPlaceholder: 'Důvod pro zrušení',
      cancelSubscriptionReasonRequiredErr: 'Důvod pro zrušení je povinný',
      cancelSubscriptionModalBackBtn: 'Zpět',
      cancelSubscriptionModalConfirmBtn: 'Potvrdit zrušení',
      cancelSubscriptionInProgressBtn: 'Ruším...',
      subscriptionCancelledMsg: 'Předplatné bylo úspěšně zrušeno',
      subscriptionCancelFailedErr: 'Zrušení předplatného se nezdařilo',
      restartSubscriptionBtn: 'Obnovit předplatné',
      restartSubscriptionInProgressBtn: 'Obnovuji...',
      subscriptionRestartedMsg: 'Předplatné bylo úspěšně obnoveno',
      subscriptionRestartFailedErr: 'Obnovení předplatného se nezdařilo',
      subscriptionManagementHeader: 'Správa předplatného',
      subscriptionCancelledStatus: 'Vaše předplatné bylo zrušeno.',
      resumeSubscriptionBtn: 'Obnovit předplatné',
      resumeSubscriptionInProgressBtn: 'Obnovuji...',
      subscriptionResumedMsg: 'Předplatné bylo úspěšně obnoveno',
      subscriptionResumeFailedErr: 'Obnovení předplatného se nezdařilo',
      manageSubscriptionBtn: 'Spravovat předplatné',
      currentSubscriptionTier: 'Aktuální úroveň předplatného',
      subscriptionTierLevel: 'Úroveň předplatného',
      subscriptionPrice: 'Cena',
      subscriptionPaymentStatus: 'Stav platby',
      subscriptionNextPaymentDate: 'Další datum platby',
      subscriptionTrialEndsAt: 'Zkušební verze končí',
      subscriptionEndsAt: 'Předplatné končí',
      subscriptionBillingPeriod: 'Fakturační období',
      subscriptionPeriodMonthly: 'Měsíčně',
      subscriptionPeriodAnnually: 'Ročně',
      subscriptionTrialStatus: 'Zkušební verze',
      subscriptionActiveStatus: 'Aktivní',
      subscriptionProcessingStatus: 'Zpracovává se',
      subscriptionPendingStatus: 'Čekající',
      subscriptionUnpaidStatus: 'Nezaplaceno',
      subscriptionNoSubscriptionStatus: 'Bez předplatného',
      subscriptionTierLimits: 'Limity úrovně',
      subscriptionAdminLimit: 'Správci',
      subscriptionMemberLimit: 'Členové',
      subscriptionProjectLimit: 'Projekty',
      subscriptionCancelledRenewHint:
        'Nemáte žádné platné předplatné. Můžete si ho obnovit pomocí tlačítka níže.',
      noSubscriptionTitle: 'Zatím bez předplatného',
      noSubscriptionDescription:
        'Spusťte předplatné a odemkněte placené funkce i opakované platby.',
      lastPaymentErrorReason: 'Poslední problém s platbou',
      tierLimitAdminsErr: 'Byl dosažen limit administrátorů pro vaši úroveň předplatného',
      tierLimitMembersErr: 'Byl dosažen limit členů pro vaši úroveň předplatného',
      tierLimitProjectsErr: 'Byl dosažen limit projektů pro vaši úroveň předplatného',
    },
    subscription: {
      requiresSubscription: 'Tato funkce vyžaduje platné předplatné',
      freeTrialHeadline: 'Začněte s 3 týdny zdarma',
      checkoutRequirement:
        'Toto je placená funkce. Nejprve v zadejte platební údaje a ověřte kartu. První platba proběhne až po 3 týdnech zdarma.',
      tiers: {
        individual: 'Individuální',
        team: 'Tým',
        organization: 'Organizace',
      },
    },

    billingForm: {
      firstName: 'Jméno',
      lastName: 'Příjmení',
      address: 'Adresa',
      city: 'Město',
      state: 'Stát',
      zipCode: 'PSČ',
      country: 'Země',
      contactEmail: 'Hlavní kontaktní email',
      contactPhone: 'Hlavní kontaktní telefon',
      companyInfo: 'Informace o společnosti',
      companyInfoOptional: '(volitelné)',
      companyName: 'Název firmy',
      ico: 'IČ',
      dic: 'DIČ',
      errors: {
        required: 'Toto pole je povinné',
        email: 'Zadejte platnou e-mailovou adresu',
        country: 'Vyberte platnou zemi',
        phoneLength: 'Telefonní číslo může mít nejvýše 20 znaků',
      },
    },
    cashFlowPage: {
      title: '{projectName}: Finance',
      companyOverview: 'Přehled projektu',
      previousMonth: 'Předchozí měsíc',
      nextMonth: 'Následující měsíc',
      showDeletedItems: 'Ukaž smazané',
      showHiddenItems: 'Ukaž schované',
      hideDeletedItems: 'Schovej smazané',
      hideItems: 'Schovej položky',
      months: {
        '01': 'Leden',
        '02': 'Únor',
        '03': 'Březen',
        '04': 'Duben',
        '05': 'Květen',
        '06': 'Červen',
        '07': 'Červenec',
        '08': 'Srpen',
        '09': 'Září',
        10: 'Říjen',
        11: 'Listopad',
        12: 'Prosinec',
      },
      categories: {
        'saldo-cumulative': 'Saldo kumulativně',
        'saldo-forecast-cumulative': 'Saldo kumulativně s forecastem',
        'forecast-cumulative': 'Forecast kumulativně',
        forecast: 'Forecast',
        'saldo-internal': 'Saldo interních projektů',
        saldo: 'Saldo',
        income: 'Příjmy',
        expense: 'Výdaje',
        'vat-estimate': 'DPH odhad',
        'vat-reality': 'DPH realita',
        1: 'Výdaje',
        2: 'Příjmy',
        3: 'Forecast výdajů',
        4: 'Forecast příjmů',
        5: 'Platy',
        6: 'Interní projekty',
      },
      defaultCapacityDialog: {
        title({ values: { employee } }) {
          return `Defaultní kapacita${employee ? ' pro ' + employee.name : ''}`;
        },
        submitBtn: 'Submit',
      },
      vatSelectDialog: {
        editTitle: 'Upravit výše daní',
        selectTitle: 'Vybrat výši daně',
        noneLabel: 'Žádná',
      },
      aggregation: {
        sum: 'Součet',
        average: 'Průměr',
        min: 'Minimum',
        max: 'Maximum',
        count: 'Počet',
      },
    },
    capacitiesPage: {
      title: '{projectName}: Kapacity',
      weekTitle: 'Týden {weekNumber}',
      projectsHeader: 'Projekty',
      previousWeek: 'Předchozí týden',
      nextWeek: 'Následující týden',
      employee: 'Člověk',
      description: 'Popis',
      capacity: 'Kapacita',
      utilization: 'Utilizace',
      workingHours: 'Dostupná kapacita',
      plan: 'Plán',
      fact: 'Realita',
      addNewEmployee: 'Přidat člověka',
      addNewProject: 'Přidat projekt',
      assignProject: 'Přiřadit projekt',
      assignInternalProject: 'Přiřadit interní projekt',
      showDeletedItems: 'Ukaž smazané',
      showHiddenItems: 'Ukaž schované',
      hideDeletedItems: 'Schovej smazané',
      hideItems: 'Schovej položky',
    },
    employeesPage: {
      title: '{projectName}: Lidé',
      employeesHeader: 'Lidé',
      addNewEmployee: 'Přidat člověka',
      previousWeek: 'Předchozí týden',
      nextWeek: 'Následující týden',
      weeksLabel: 'Týden {start} - {end}',
      weekTitle: 'Týden {weekNumber}',
      plan: 'Plán',
      fact: 'Realita',
      capacity: 'Kap',
      noAssignedProjects: 'Tento člověk nemá přiřazené žádné projekty.',
      assignProject: 'Přiřadit projekt',
      assignProjectTo: 'Přiřadit projekt k {employeeName}',
    },
    projectsPage: {
      title: '{projectName}: Projekty',
      projectsHeader: 'Projekty',
      addNewProject: 'Přidat nový projekt',
      previousWeek: 'Předchozí týden',
      nextWeek: 'Následující týden',
      weeksLabel: 'Týden {start} - {end}',
      weekTitle: 'Týden {weekNumber}',
      plan: 'Plán',
      fact: 'Realita',
    },
    timesheetsPage: {
      title: '{projectName}: Timesheet',
      selectPerson: 'Vybrat člověka',
      weekTitle: 'Týden {weekNumber}',
      projectsHeader: 'Projekty',
      previousWeek: 'Předchozí týden',
      nextWeek: 'Následující týden',
      'calculated-plan': 'Plán',
      'calculated-fact': 'Realita',
      'calculated-capacity': 'Kapacita',
      'calculated-onload': 'Vytížení',
      assignProject: 'Přiřadit projekt',
      showHiddenItems: 'Ukaž schované',
      hideItems: 'Schovej položky',
      columnHeader: ({ values: { columnId } }) => {
        if (columnId === 'total-plan') {
          return 'TOTAL PLÁN';
        }
        if (columnId === 'total-fact') {
          return 'TOTAL REALITA';
        }
        const date = new Date(columnId);
        const [, m, d] = columnId.split('-');
        const dayNum = date.getDay();
        const days = ['Neděle', 'Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota'];
        return `${days[dayNum]} ${d}. ${m}.`;
      },
    },
    workReportsPage: {
      title: '{projectName}: Výkazy práce',
      workReportsHeader: 'Výkazy práce',
      projectColumn: 'Projekt:',
      employeeColumn: 'Člověk:',
      employeeDialogSearchPlaceholder: 'Jméno...',
      projectDialogSearchPlaceholder: 'Projekt...',
      dateColumn: 'Datum:',
      invoiceColumn: 'Faktura:',
      noteColumn: 'Poznámka:',
      hoursColumn: 'Hodiny:',
      yesNoBoolean: {
        1: 'Ano',
        0: 'Ne',
        null: '-',
      },
      csvExportBtn: 'CSV Export',
      saveRow: 'Uložit',
      discardRow: 'Zahodit změny',
      resetRow: 'Vynulovat',
      deleteNewRow: 'Smazat',
      newWorkReport: 'Nový výkaz práce',
      itemsPerPage: 'Řádků na stránku',
      forceUpdateDialog: {
        title:
          'Výkaz práce pro daného člověka, projekt a den se zadaným časem, poznámkou nebo fakturou už existuje. Chcete ho přepsat?',
        overwriteBtn: 'Přepsat',
        cancelBtn: 'Zrušit',
      },
      assignProject: 'Přiřadit projekt',
    },
  },
};
